import cookies from './cookies'

const TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const UUID_KEY = 'uuid'
const USER_NAME = 'username'

/**
 * 获取tonken
 */
export function getToken() {
    // let r = cookies.get(TOKEN_KEY)
    // // 开发模式使用默认 token , 这个 token 使用期限为永久
    // if (process.env.NODE_ENV.includes('dev') && !r) {
    //     return  '677823181888819200'
    // }
	// return r
	return cookies.get(TOKEN_KEY)
}

export function setToken(token, options) {
    return cookies.set(TOKEN_KEY, token, options)
}

export function removeToken() {
    return cookies.remove(TOKEN_KEY)
}